import classNames from 'classnames';
import * as React from 'react';

import { TableHeaderItem } from 'components/Filter/TableHeaderItem';

import { t } from 'utils';

import { TASKS_COLUMNS } from '../../constants';

import { HeadersType } from './';

const { MAIN_COLUMNS, COLUMN_WIDTH } = TASKS_COLUMNS;

const classes = {
  thead: {
    regular: ['start-list-table-header', 'filter-item'],
  },
};

const RacersHeadersComponent: React.FC<HeadersType> = function () {
  return MAIN_COLUMNS.map((column) => {
    const width = COLUMN_WIDTH[column];
    const className = `cell-${column}`;
    const translation = t.staticAsString(`supportTaskManager.list.fields.${column}` as TranslationLockedKeys);

    return (
      <TableHeaderItem
        key={column}
        name={column}
        width={width}
        className={classNames(...classes.thead.regular, className)}
        label={translation}
      />
    );
  }) as any;
};

const TasksHeaders = React.memo<HeadersType>(RacersHeadersComponent);
export { TasksHeaders };
